import { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { FontEnum } from "../../../../SharedComponents/utils/enums/FontEnum";
import NotificationsTableRow from "../TableRows/NotificationsTableRow";
import { getNewNotifications } from "../../../reduxStore/entities/notifications";

const NewNotificationsTable = () => {
    const dispatch = useDispatch();

    const [loaded, setLoaded] = useState(false);

    const fetchedNewNotifications = useSelector((state) => state.notifications.newNotifications);
    const count = useSelector((state) => state.notifications.count);

    useEffect(() => {
        setLoaded(true);
    }, [fetchedNewNotifications]);

    useEffect(() => {
        dispatch(getNewNotifications());
    }, []);

    if (!loaded) {
        return null;
    };

    const title = `Nova obaveštenja (${count})`;

    return (
        <div style={styles.mainContainer}>
            <p style={styles.title}>
                {title}
            </p>

            <div style={styles.notificationComponent}>
                {fetchedNewNotifications.map((notification, index) => {
                    return (
                        <NotificationsTableRow
                            key={index}
                            notification={notification}
                        />
                    );
                })}
            </div>

        </div>
    );
};

export default NewNotificationsTable;

const styles = {
    mainContainer: {
        width: "33%"
    },
    title: {
        fontFamily: FontEnum.TITILIUM_WEB,
        fontWeight: 600,
        fontSize: "24px",
        color: "rgba(0, 0, 0, 0.87)"
    },
    notificationComponent: {
        marginTop: 25
    }
};